module.exports = __webpack_public_path__ + "static/media/dm.c46af913.svg";